import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { DropdownProvider } from './context/DropdownContext';
import { AuthProvider } from './context/AuthContext';
import Splash from './components/Splash';

const LazyApp = lazy(() => import("./App"));

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <AuthProvider>
    <DropdownProvider>
      <Suspense fallback={<Splash />}>
        <LazyApp />
      </Suspense>
      <ToastContainer />
    </DropdownProvider>
  </AuthProvider>
);
